var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 5.99961C6.9993 6.14325 6.93791 6.2808 6.82917 6.38221L1.00136 11.8341C0.947572 11.8861 0.883271 11.9275 0.812203 11.956C0.741134 11.9844 0.664717 11.9994 0.587409 12C0.5101 12.0006 0.433444 11.9867 0.361901 11.9593C0.290358 11.9319 0.22536 11.8915 0.170693 11.8403C0.116025 11.7892 0.0727843 11.7284 0.0434826 11.6614C0.0141809 11.5945 -0.00059574 11.5228 1.83856e-05 11.4505C0.000632511 11.3782 0.0166245 11.3067 0.0470591 11.2402C0.0774937 11.1737 0.121763 11.1135 0.177292 11.0632L5.59613 5.99388L0.177292 0.924532C0.070865 0.821754 0.0118964 0.683952 0.0131115 0.540863C0.0143265 0.397774 0.0756269 0.260867 0.183786 0.159684C0.291944 0.0585012 0.438292 0.00115395 0.591247 1.71661e-05C0.744201 -0.00111961 0.891501 0.0540466 1.00136 0.153609L6.82917 5.60555C6.88449 5.65711 6.92813 5.71859 6.95747 5.7863C6.9868 5.85401 7.00124 5.92656 6.99992 5.99961Z",
    fill: "#285680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/nextArrow.734859a6c2decb9acf5204805fa7437e.svg";
export { ForwardRef as ReactComponent };